import clsx from 'clsx'
import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'

const useStyles = makeStyles(pointsStyles)

export default function Points({className, context}) {

  const classes = useStyles()
  const {translate} = context

  const points = Object.values(context.quizQuestions).reduce((acc, section) => {
    return section.reduce((acc, {value}) => acc + value, acc)
  }, 0)

  return (<Box className={clsx(className, classes.root)}>
    <Box className={clsx(classes.label, "label")}>{translate('total-points')}:</Box>
    <Box className={clsx(classes.input, "input")}>
      {points}
    </Box>
  </Box>)
}

function pointsStyles(theme) {

  return {
    root: {
    },
    input: {
      display: 'flex',
      border: 'solid 1px #edf4fe',
      backgroundColor: '#edf4fe',
      borderRadius: 4,
      cursor: 'text',
      color: '#4f5a70',
      padding: 5
    }
  }
}
